import React, { memo, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Stack,
  Icon,
  Grid,
  Card,
  TextField,
  LoadingButton,
} from "investira.react.components";
import { VALIDATIONS } from "../../../const";
import services from "../../../services";
import withResponseHandling from "../../../hoc/withResponseHandling";

const EnquadramentoAdd = memo((props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [enquadramento, setEnquandramento] = useState({});
  const [regras, setRegras] = useState([]);

  const VALIDATION_SCHEMA = Yup.object().shape({
    enquadramento: Yup.string()
      .max(128, "Máximo de 128 caracteres")
      .required(VALIDATIONS.REQUIRED),
  });

  const formik = useFormik({
    initialValues: { enquadramento: "" },
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: false,
    onSubmit: (pValues, pActions) => {
      pActions.setSubmitting(true);
      services.enquadramentos.add(
        {
          data: { enquadramento: pValues.enquadramento },
        },
        (rRes) => {
          const { enquadramento_id } = rRes.data;
          navigate(
            `${location.pathname.replace(/\/add$/, "")}/${enquadramento_id}`,
            { state: rRes.data }
          );
        },
        (rErr) => {
          props.responseErrorHandling(rErr);
        },
        () => {
          pActions.setSubmitting(false);
        }
      );
    },
  });

  return (
    <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack spacing={2}>
            <Card>
              <Stack spacing={2} sx={{ pt: 3, pb: 2, px: 2 }}>
                <TextField
                  id="enquadramento"
                  label="Enquadramento"
                  value={formik.values.enquadramento}
                  onChange={formik.handleChange}
                  variant="outlined"
                  placeholder={"Digite um nome para o enquadramento"}
                  fullWidth
                  disabled={props.isSubmitting}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Stack direction="row" justifyContent="flex-end">
                  <LoadingButton
                    variant="contained"
                    color="primary"
                    startIcon={
                      <Icon color="secondary" iconName="save" size={16} />
                    }
                    sx={{ px: 2 }}
                    type="submit"
                    disabled={formik.isSubmitting}
                    loading={formik.isSubmitting}
                  >
                    Salvar
                  </LoadingButton>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        </Grid>
      </Grid>
    </form>
  );
});

export default withResponseHandling(EnquadramentoAdd);
